import {
    SET_DOCUMENTS
} from '../../actions';

const initialState = {
    list: []
}

function documentsListReducer(state = initialState, action ) {
    const newState = {};

    switch (action.type) {
        case SET_DOCUMENTS:
            newState.list = action.documents;
            return newState;
        
        default:
            return state;

    }
}

export default documentsListReducer;
